import { Navigate, Outlet } from 'react-router-dom';

import { useGetCustomerConfigurations } from 'api';

import { useOrganisationId } from 'hooks/context';

import { Loading } from 'components/pages/Loading';

export const RequireBatchesEnabled = () => {
  const organisationId = useOrganisationId<number>();

  const {
    data: { data: orgSettingsData } = {},
    isSuccess: orgSettingsSuccess,
    isLoading: orgSettingsLoading,
    isError: orgSettingsError
  } = useGetCustomerConfigurations(organisationId);

  const isBatchesPageEnabled =
    orgSettingsData?.batches_enabled !== undefined &&
    Number(orgSettingsData.batches_enabled) > 0;

  return (
    <>
      {orgSettingsLoading && <Loading text="Loading data..." />}
      {orgSettingsError && <Navigate to={`/org/${organisationId}`} replace />}
      {orgSettingsSuccess &&
        (isBatchesPageEnabled ? (
          <Outlet />
        ) : (
          <Navigate to={`/org/${organisationId}`} replace />
        ))}
    </>
  );
};
